import convertTimeLabelsToGridLabels from '../utils/convertTimeLabelsToGridLabels';
import getGridLines from '../utils/getGridLines';
import React from 'react';
import strings from 'owa-strings/owa-mini-calendar-strings';
import { DateRange } from 'mini-datetime-utils';
import { DEFAULT_PIXELS_PER_MINUTE } from '../utils/constants';
import { GridLayerInfo } from '../schema/GridLayerInfo';
import { mergeStyles } from '@uifabric/merge-styles';

const styles = require('./GridLayer.scss');
const classNames = require('classnames');

/**
 * Grid layer props
 */
interface GridLayerProps {
    /**
     * Grid layer range
     */
    range: DateRange;
    /**
     * Grid layer additional info
     */
    gridInfo: GridLayerInfo;
    /**
     * pixel per minute configuration of grid
     */
    pixelsPerMin?: number;
    isExpanded?: boolean;
    onClickAllDayLabel?: (isExpanded: boolean) => void;
}

/**
 * Component which renders the day view lines and time labels
 * @param props
 */
export default function GridLayer(props: GridLayerProps) {
    const { range, gridInfo, pixelsPerMin = DEFAULT_PIXELS_PER_MINUTE, onClickAllDayLabel } = props;
    const { start, end } = range;
    const {
        firstLineStartTime,
        repeatIntervalInMin,
        labels,
        formatTime,
        labelContainerStyles,
        showAllDayLabel = false,
    } = gridInfo;

    const gridLines = getGridLines(start, end, firstLineStartTime, repeatIntervalInMin);

    const gridLabels = convertTimeLabelsToGridLabels(start, end, labels, formatTime);

    return (
        <div aria-hidden className={styles.gridLayerWrapper}>
            {showAllDayLabel && (
                <div
                    role="button"
                    className={styles.allDayLabelContainer}
                    onClick={() => {
                        onClickAllDayLabel(showAllDayLabel);
                    }}>
                    <div className={styles.allDayLabelInner}>{strings.allDayEventTimeLabel}</div>
                </div>
            )}
            <div className={styles.gridLinesLayer}>
                {gridLines.map((item, index) => (
                    <hr
                        className={classNames(
                            styles.gridLine,
                            mergeStyles({
                                top: item.top * pixelsPerMin + 'px',
                            }),
                            // At the 30 min mark dashed border is selected otherwise solid border is selected.
                            index % 2 === 0 ? styles.solidBorder : styles.dashedBorder
                        )}
                        key={item.key}
                    />
                ))}
            </div>
            <div className={classNames(styles.gridLabelsLayer, labelContainerStyles)}>
                {gridLabels.map(item => (
                    <div
                        className={classNames(
                            styles.gridLabel,
                            mergeStyles({
                                top: item.top * pixelsPerMin + 'px',
                            })
                        )}
                        key={`gridLabel_${item.top}`}>
                        {item.labelText}
                    </div>
                ))}
            </div>
        </div>
    );
}
